import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export const FILLABLE_PDF_LIST_DOC_ID = 'tb_fillable_forms'

export class FillablePdfsService extends ClientDataService {
  async getFillablePdfBlobDoc(pdfId: string): Promise<IClientDataDoc | undefined | null> {
    return this.getDocument(pdfId)
  }

  async getFillablePdfMetadataDoc(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(FILLABLE_PDF_LIST_DOC_ID)
  }
}
